import React from "react";
import { Button } from "@/components/ui/button";
import { Close } from "@dreamhub/designsystem/icons";
import { IconButton } from "@/components/ui/icon-button";
import ToastBody from "@/components/ui/toast-body";

interface UndoToastProps {
  message: string;
  onUndo: () => void;
  onDismiss: () => void;
}

const UndoToast: React.FC<UndoToastProps> = ({
  message,
  onUndo,
  onDismiss
}) => {
  return (
    <ToastBody
      title={message}
      actions={
        <>
          <Button
            variant="secondaryNoBg"
            onClick={onUndo}
            className="text-primary border-border-border2 hover:bg-surface-elevation2"
          >
            Undo
          </Button>
          <IconButton
            variant="iconNoBg"
            iconColor="secondary"
            size="md"
            onClick={onDismiss}
          >
            <Close />
          </IconButton>
        </>
      }
    />
  );
};

export default UndoToast;
